import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7948dab0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = { class: "first-column-with-icon-type" }
const _hoisted_6 = { class: "name-type-block" }
const _hoisted_7 = { class: "name-data" }
const _hoisted_8 = { class: "type-data-mini" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "emq-table-footer" }
const _hoisted_11 = { class: "wallet-summary-content" }
const _hoisted_12 = { class: "summary-item" }
const _hoisted_13 = { class: "item-label" }
const _hoisted_14 = { class: "item-value" }
const _hoisted_15 = { class: "summary-item" }
const _hoisted_16 = { class: "item-label" }
const _hoisted_17 = { class: "item-value" }
const _hoisted_18 = { class: "summary-item" }
const _hoisted_19 = { class: "item-label" }
const _hoisted_20 = { class: "item-value" }
const _hoisted_21 = { class: "dialog-footer" }

import { getUserList, userUnbindEvse, banUser, GetUserWalletSummary } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus} from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { ElMessage, ElMessageBox } from 'element-plus'
import AdosBrief from '@/components/AdosBrief.vue'
import UserBindEvse from './components/UserBindEvse.vue'
import UserEditDialog from './components/UserEditDialog.vue'
import SelectOperator from '@/components/SelectOperator.vue'
import { checkMenuShow } from '@/store/tool'
import { dateFormat, throttleBtn } from '@/common/tools'
import LinkOperator from '@/components/Links/LinkOperator.vue'
import LinkUser from '@/components/Links/LinkUser.vue'
import PermissionLink from '@/components/PermissionLink.vue'

import { defineComponent, ref } from 'vue'

const __default__ = defineComponent({
  name: 'Users',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('Operation')

const showUser = ref({ id: '', operatorID: '' })
const showDialog = ref(false)
const showBindDialog = ref(false)
const showWalletSummaryDialog = ref(false)  // 新增
const walletSummary = ref({ balance: 0, principal: 0, gift: 0, walletCount: 0 })  
const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { enableSelects, evseStateSelects } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')

const editUserDialog = (row: any) => {
  showUser.value = row
  showDialog.value = true
}

const bindEvseDialog = (row: any) => {
  showUser.value = row
  showBindDialog.value = true
}

const handleSwitchStatus = async (row: any) => {
  try {
    await banUser(row.id, !row.enable)
    if (!row.enable) {
      ElMessage.success(t('Base.disabledSuccess'))
    } else {
      ElMessage.success(t('Base.enableSuccess'))
    }

    await loadUsers()
    return Promise.resolve()
  } catch (error) {
    console.error(error)
    return Promise.reject()
  }
}

const unuseAdo = async (userid: string, ado: any) => {
  if (!checkMenuShow('driverBindEvse')) {
    ElMessage.success(t('Base.permissionDenied'))
    return
  }
  try {
    await ElMessageBox.confirm(t('Base.confirmDelete'), {
      confirmButtonText: t('Base.confirm'),
      cancelButtonText: t('Base.cancel'),
      confirmButtonClass: 'confirm-danger',
      type: 'warning',
    })
    await userUnbindEvse({
      userID: userid,
      bindEvse: ado,
    })
    ElMessage.success(t('Base.deleteSuccess'))
    loadUsers()
    return Promise.resolve()
  } catch (error) {
    console.error(error)
    return Promise.reject()
  }
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadUsers()
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { id, name, enable, operatorID, sn } = params
  newParams = {
    id: id || undefined,
    name: name || undefined,
    enable: enable || undefined,
    operatorID: operatorID || undefined,
    sn: sn || undefined,
  }
  return newParams
}

const loadUsers = async () => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
    },
  }

  try {
    const { list = [], pageReply = {} } = await getUserList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadUsers)

const showUserWalletSummary = async () => {
  try {
    const result = await GetUserWalletSummary({ });
    walletSummary.value = result;  // 将数据存储到变量中
    showWalletSummaryDialog.value = true;  // 打开弹窗
  } catch (error) {
    console.error('获取用户钱包摘要失败:', error);
  }
}

// 添加弹窗关闭处理函数
const handleClose = () => {
  showWalletSummaryDialog.value = false;
}

loadUsers()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "search-wrapper",
      onKeyup: _withKeys(handleSearch, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.id) = $event)),
                  placeholder: _ctx.$t('Evses.id'),
                  clearable: "",
                  onClear: handleSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.name) = $event)),
                  placeholder: _ctx.$t('Base.account'),
                  clearable: "",
                  onClear: handleSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: fuzzyParams.value.enable,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.enable) = $event)),
                  placeholder: _ctx.$t('Base.isEnabled'),
                  clearable: "",
                  onClear: handleSearch
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(enableSelects), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        value: item.value,
                        key: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            (showMoreQuery.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                    default: _withCtx(() => [
                      _createVNode(SelectOperator, {
                        modelValue: fuzzyParams.value.operatorID,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fuzzyParams.value.operatorID) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 16),
                  _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: fuzzyParams.value.sn,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((fuzzyParams.value.sn) = $event)),
                        placeholder: _ctx.$t('Evses.sn'),
                        clearable: "",
                        onClear: handleSearch
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 16)
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  icon: _unref(Search),
                  onClick: handleSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(RefreshLeft),
                  onClick: handleReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_tooltip, {
                  content: !showMoreQuery.value ? _ctx.$t('Base.showMore') : _ctx.$t('Base.lessMore'),
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "icon-button",
                      plain: "",
                      icon: showMoreQuery.value ? _unref(ArrowUp) : _unref(ArrowDown),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (showMoreQuery.value = !showMoreQuery.value))
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onKeyup"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: showUserWalletSummary
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.userSummary')), 1)
          ]),
          _: 1
        })
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "account",
            "min-width": "80",
            label: _ctx.$t('Base.account'),
            show: "false",
            align: "center",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkUser, {
                id: row.id,
                name: row.account
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            "min-width": "80",
            label: _ctx.$t('Operation.operator'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkOperator, {
                id: row.operatorID,
                name: row.operatorName
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "nickName",
            "min-width": "80",
            label: _ctx.$t('Base.nickname'),
            show: "false",
            "show-overflow-tooltip": ""
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "phone",
            "min-width": "120",
            label: _ctx.$t('Operation.contactmt'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(row.phone ? row.phone : '-'), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(row.email ? row.email : '-'), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "enable",
            label: _ctx.$t('Base.enable')
          }, {
            default: _withCtx(({ row }) => [
              (!row.isAct)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(t)('Base.deletedAccount')), 1))
                : (_openBlock(), _createBlock(_component_el_switch, {
                    key: 1,
                    modelValue: row.enable,
                    "onUpdate:modelValue": ($event: any) => ((row.enable) = $event),
                    onChange: ($event: any) => (handleSwitchStatus(row)),
                    disabled: !_unref(checkMenuShow)('driverBan')
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"]))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "evse",
            "min-width": "80",
            label: _ctx.$t('Operation.ownevse')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(AdosBrief, {
                ados: row.bindEvses,
                objid: row.id,
                colse: unuseAdo
              }, null, 8, ["ados", "objid"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "createdAt",
            "min-width": "80",
            label: _ctx.$t('Base.regtime')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(PermissionLink, {
                to: {
                name: 'user-detail',
                params: { id: row.id },
              },
                role: ['driverInfo']
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Base.detail')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["to"]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (editUserDialog(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'driverUpsert']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (bindEvseDialog(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.bind')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'driverBindEvse']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[6] || (_cache[6] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadUsers
        }, null, 8, ["metaData"])
      ]),
      _createVNode(UserBindEvse, {
        modelValue: showBindDialog.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showBindDialog).value = $event)),
        userID: showUser.value.id,
        operatorID: showUser.value.operatorID,
        onSubmitted: loadUsers
      }, null, 8, ["modelValue", "userID", "operatorID"]),
      _createVNode(UserEditDialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showDialog).value = $event)),
        user: showUser.value,
        onSubmitted: loadUsers
      }, null, 8, ["modelValue", "user"]),
      _createVNode(_component_el_dialog, {
        modelValue: showWalletSummaryDialog.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showWalletSummaryDialog).value = $event)),
        title: _ctx.$t('Base.userSummary'),
        width: "25%",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_21, [
            _createVNode(_component_el_button, {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (showWalletSummaryDialog.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Base.close')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('Base.balance')) + ":", 1),
              _createElementVNode("span", _hoisted_14, _toDisplayString(walletSummary.value.balance), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('Order.principal')) + ":", 1),
              _createElementVNode("span", _hoisted_17, _toDisplayString(walletSummary.value.principal), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('Base.gift')) + ":", 1),
              _createElementVNode("span", _hoisted_20, _toDisplayString(walletSummary.value.gift), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ])
  ]))
}
}

})